import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdvorBreadcrumbComponent } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { CustomBreadcrumbComponent } from './custom-breadcrumb.component';

@NgModule({
  imports: [
    NgIf,
    AsyncPipe,
    SdvorBreadcrumbComponent,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        BreadcrumbComponent: {
          component: CustomBreadcrumbComponent,
        },
      },
    }),
  ],
  declarations: [CustomBreadcrumbComponent],
  exports: [CustomBreadcrumbComponent],
})
export class CustomBreadcrumbModule {}
